function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Table from "react-bootstrap/Table";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import GenerateToken from "./../img/generate-token.jpg";
import { useCopyToClipboard } from "react-use";
import ControlLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import "./ApiToken.css";
import Dropdown from "react-bootstrap/Dropdown";
import { GENERATE_API_TOKEN_MUTATION, API_TOKEN_LIST_QUERY, DELETE_API_TOKEN_MUTATION } from "./query";
import { useQuery, useMutation } from "@apollo/client";
import { FilterContext } from "../index";
import Loader from "./../Loader/Loader";
import moment from "moment-timezone";
import { toast } from "react-toastify";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Alert from "react-bootstrap/Alert";
var ApiSchema = Yup.object().shape({
  apiTokenName: Yup.string().trim().required("Required")
});
var ApiTokens = function ApiTokens(props) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    createTokenShow = _React$useState2[0],
    setCreateTokenShow = _React$useState2[1];
  var _React$useContext = React.useContext(FilterContext),
    organisationId = _React$useContext.organisationId,
    organisationBilling = _React$useContext.organisationBilling,
    from = _React$useContext.from,
    role = _React$useContext.role,
    organisationSettings = _React$useContext.organisationSettings;
  React.useEffect(function () {
    if (from == "web" &&
    // (organisationId != "1f36f580-4b7f-11ef-aa29-61222eb37f44" &&
    // organisationId != "f2c9e240-4e71-11eb-9784-794f853f90e2" &&
    // organisationId != "fda760b0-aab9-11ed-92b3-5dc7b3cd7496" &&
    // organisationId != "f979b350-23b5-11ef-8a95-77fbcc485e69" &&
    // organisationId != "6ed1d9d0-538f-11ef-aa29-61222eb37f44" &&
    // organisationId != "c1ec8a00-52ca-11ee-8786-3b026eafe561" &&
    // organisationId != "535a42d0-664b-11f0-a18d-33f6e73bb9c3") ||
    !organisationSettings.enableApiAccess) {
      props === null || props === void 0 ? void 0 : props.history.push("/overview");
    }
  }, []);
  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var handleShow = function handleShow() {
    return setCreateTokenShow(true);
  };
  var _useQuery = useQuery(API_TOKEN_LIST_QUERY, {
      variables: {
        organisationId: organisationId
      }
      // skip: !loadPage,
    }),
    apiTokenListData = _useQuery.data,
    apiTokenListError = _useQuery.error,
    apiTokenListLoading = _useQuery.loading;
  if (apiTokenListLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (apiTokenListError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!apiTokenListData) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "api-tokens-list-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "api-tokens-list-card-toolbar"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("div", null, " ", /*#__PURE__*/React.createElement(Alert, {
    key: "api-limit-waring",
    variant: "warning",
    className: "api-tokens-list-card-toolbar-alert-text"
  }, "Note: You can create up to 3 API tokens only.")), (apiTokenListData === null || apiTokenListData === void 0 ? void 0 : apiTokenListData.apiTokenList.length) >= 3 ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "You can create up to 3 API tokens only")
  }, /*#__PURE__*/React.createElement("div", {
    className: "api-tokens-list-card-create-new-token-button upgrade-plan-button-color"
  }, "Create New Token")) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "api-tokens-list-card-create-new-token-button",
    onClick: handleShow
  }, "Create New Token"))), /*#__PURE__*/React.createElement("div", {
    className: "api-tokens-list-card-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "api-tokens-list-card-data"
  }, (apiTokenListData === null || apiTokenListData === void 0 ? void 0 : apiTokenListData.apiTokenList.length) > 0 ? /*#__PURE__*/React.createElement(Table, {
    responsive: "sm",
    className: "api-tokens-list-card-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "api-tokens-list-card-table-header"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Name"), /*#__PURE__*/React.createElement("th", null, "Token"), /*#__PURE__*/React.createElement("th", null, "Created"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", {
    className: "api-tokens-list-card-table-body"
  }, apiTokenListData === null || apiTokenListData === void 0 ? void 0 : apiTokenListData.apiTokenList.map(function (apiList, key) {
    return /*#__PURE__*/React.createElement("tr", {
      className: "api-tokens-list-card-table-data-details"
    }, /*#__PURE__*/React.createElement("td", null, apiList.apiName), /*#__PURE__*/React.createElement("td", null, "***********************", apiList.apiToken.slice(apiList.apiToken.length - 5)), /*#__PURE__*/React.createElement("td", null, moment.unix(Number(apiList.createdAt) / 1000).format("DD MMM, YYYY")), /*#__PURE__*/React.createElement("td", {
      className: "api-token-edit-menu-td"
    }, /*#__PURE__*/React.createElement(KebabMenu, {
      apiToken: apiList.apiToken,
      apiName: apiList.apiName,
      organisationId: organisationId
    })));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "api-token-no-data"
  }, "Yet to generate API token !!!")), /*#__PURE__*/React.createElement("div", {
    className: "api-token-reference-link"
  }, "* Please refer this link (", /*#__PURE__*/React.createElement("a", {
    className: "api-token-reference-link-tag",
    href: "https://app.swaggerhub.com/apis/getworkfolio/GetWorkfolio/1.0.0",
    target: "_blank"
  }, "https://app.swaggerhub.com/apis/getworkfolio/GetWorkfolio/1.0.0"), ") to see our live API documentation")), /*#__PURE__*/React.createElement(CreateTokenModal, {
    createTokenShow: createTokenShow,
    organisationId: organisationId,
    setCreateTokenShow: setCreateTokenShow
  }));
};
var KebabMenu = function KebabMenu(props) {
  var apiToken = props.apiToken,
    apiName = props.apiName,
    organisationId = props.organisationId;
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    apiTokenShow = _React$useState4[0],
    setApiTokenShow = _React$useState4[1];
  var handleClose = function handleClose() {
    return setApiTokenShow(false);
  };
  var handleShow = function handleShow() {
    return setApiTokenShow(true);
  };
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    showDeleteModal = _React$useState6[0],
    setShowDeleteModal = _React$useState6[1];
  var handleDeleteClose = function handleDeleteClose() {
    return setShowDeleteModal(false);
  };
  var handleDeleteShow = function handleDeleteShow() {
    return setShowDeleteModal(true);
  };
  var onSubmit = function onSubmit() {
    return onSubmit();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown, {
    className: "api-token-edit-menu"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    variant: "success",
    id: "dropdown-basic"
  }, /*#__PURE__*/React.createElement(HiOutlineDotsVertical, {
    className: "api-token-edit-menu-icon"
  })), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    className: "api-token-delete-task",
    onClick: handleDeleteShow
  }, "Delete Api Key"))), /*#__PURE__*/React.createElement(EditApiModal, {
    apiTokenShow: apiTokenShow,
    handleClose: handleClose
  }), /*#__PURE__*/React.createElement(DeleteApiModal, {
    showDeleteModal: showDeleteModal,
    handleDeleteClose: handleDeleteClose,
    apiToken: apiToken,
    apiName: apiName,
    organisationId: organisationId
  }));
};
var EditApiModal = function EditApiModal(props) {
  var apiTokenShow = props.apiTokenShow,
    handleClose = props.handleClose;
  return /*#__PURE__*/React.createElement(Modal, {
    show: apiTokenShow,
    onHide: handleClose,
    centered: true
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "manage-team-modal-title"
  }, "Edit Api Name")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      apiName: "test"
    }
    // validationSchema={MembersSchema}
    // onSubmit={handleSubmit}
  }, function (_ref) {
    var setFieldValue = _ref.setFieldValue;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "apiName"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "project-details-edit-task-label-name"
      }, "Api Name"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "text",
        placeholder: "Enter the name",
        className: "project-details-edit-task-label-input"
      }, field)));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "manage-team-modal-button"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outline-secondary",
      onClick: handleClose,
      className: "manage-team-modal-close-button"
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      onClick: handleClose,
      className: "manage-team-modal-save-button"
    }, "Save")))))));
  })));
};
var DeleteApiModal = function DeleteApiModal(props) {
  var showDeleteModal = props.showDeleteModal,
    handleDeleteClose = props.handleDeleteClose,
    apiToken = props.apiToken,
    apiName = props.apiName,
    organisationId = props.organisationId;
  var _useMutation = useMutation(DELETE_API_TOKEN_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    deleteApiToken = _useMutation2[0],
    deleteApiTokenLoading = _useMutation2[1].loading;
  var handleApiTokenDelete = React.useCallback(function () {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!deleteApiTokenLoading) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.next = 4;
            return deleteApiToken({
              variables: {
                apiToken: apiToken,
                organisationId: organisationId
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: API_TOKEN_LIST_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 4:
            response = _context.sent;
            if (!(!response || !response.data || response.data.deleteApiToken === null)) {
              _context.next = 9;
              break;
            }
            throw new Error("error");
          case 9:
            handleDeleteClose();
            toast.success("Api Token deleted successfully!");
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }, [deleteApiToken, deleteApiTokenLoading]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: showDeleteModal,
    onHide: handleDeleteClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete Api Token")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, "Are you sure you want to delete api token", " ", /*#__PURE__*/React.createElement("span", {
    className: "project-details-task-card-delete-task-name"
  }, apiName, "?"), " If you remove it, you can\u2019t use it anymore."), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleDeleteClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: handleApiTokenDelete()
  }, deleteApiTokenLoading ? "Loading..." : "Delete")));
};
var CreateTokenModal = function CreateTokenModal(props) {
  var createTokenShow = props.createTokenShow,
    organisationId = props.organisationId,
    setCreateTokenShow = props.setCreateTokenShow;
  var _React$useState7 = React.useState(null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isApiTokenEnable = _React$useState8[0],
    setApiTokenEnable = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isGenerateButtonEnable = _React$useState10[0],
    setGenerateButtonStatus = _React$useState10[1];
  var _useCopyToClipboard = useCopyToClipboard(),
    _useCopyToClipboard2 = _slicedToArray(_useCopyToClipboard, 2),
    state = _useCopyToClipboard2[0],
    copyToClipboard = _useCopyToClipboard2[1];
  var _React$useState11 = React.useState(null),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    copied = _React$useState12[0],
    setCopied = _React$useState12[1];
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    isAnyCopied = _React$useState14[0],
    setIsAnyCopied = _React$useState14[1];
  var _React$useState15 = React.useState("null"),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    apiTokenName = _React$useState16[0],
    setApiTokenName = _React$useState16[1];
  var _React$useState17 = React.useState("null"),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    apiToken = _React$useState18[0],
    setApiToken = _React$useState18[1];
  var handleClose = function handleClose() {
    setCreateTokenShow(false);
    setApiTokenEnable(false);
    setApiTokenName("null");
    setApiToken("null");
  };
  var handleCopyToClipboard = React.useCallback(function (text, inviteId) {
    return function () {
      copyToClipboard(text);
      setCopied(true);
      if (!isAnyCopied) {
        setIsAnyCopied(true);
      }
      setTimeout(function () {
        setCopied(true);
      }, 5000);
    };
  }, [isAnyCopied, copyToClipboard]);
  React.useEffect(function () {
    if (state.error) {
      setCopied(null);
      return;
    }
  }, [state]);
  var _useMutation3 = useMutation(GENERATE_API_TOKEN_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    generateApiToken = _useMutation4[0],
    generateApiTokenLoading = _useMutation4[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values, actions) {
      var response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!generateApiTokenLoading) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.prev = 2;
            _context2.next = 5;
            return generateApiToken({
              variables: {
                apiName: values.apiTokenName.trim(),
                organisationId: organisationId
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: API_TOKEN_LIST_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 5:
            response = _context2.sent;
            if (!response || !response.data || response.data.generateApiToken === "error") {
              toast.error("Error generating api token");
            }
            setApiTokenName(values.apiTokenName);
            setApiToken(response.data.generateApiToken);
            setApiTokenEnable(true);
            actions.setSubmitting(false);
            actions.resetForm();
            toast.success("Api token generated successfully!");
            _context2.next = 19;
            break;
          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](2);
            console.log(_context2.t0);
            actions.setSubmitting(false);
          case 19:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 15]]);
    }));
    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }(),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [generateApiToken, generateApiTokenLoading]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: createTokenShow,
    onHide: handleClose,
    className: "create-api-tokens-name-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "create-api-tokens-name-modal-header"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "create-api-tokens-name-modal-title"
  }, "Create New Api Token")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "create-api-tokens-name-modal-body"
  }, !isApiTokenEnable ? /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      apiTokenName: ""
      //apiToken: "",
    },
    validationSchema: ApiSchema,
    onSubmit: handleSubmit
  }, function (_ref4) {
    _objectDestructuringEmpty(_ref4);
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("div", {
      className: ""
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "apiTokenName"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "create-api-tokens-modal-label-name"
      }, "Api Token Name"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "control-label error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        name: "name",
        type: "text",
        placeholder: "Enter the name",
        className: "create-api-tokens-modal-label-input"
      }, field)));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "generateTokenHeader"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12
    }, /*#__PURE__*/React.createElement("img", {
      src: GenerateToken
    })), /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      className: "generate-token-btn btn",
      disabled: isGenerateButtonEnable
    }, generateApiTokenLoading ? "Loading..." : "Generate Token"))), /*#__PURE__*/React.createElement(Col, {
      xs: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "warning"
    }, "For security reasons, we can show you this API token only once. Please copy it and save it somewhere safe. If you lose it, you'll be able to regenerate it."))))));
  }) : /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    md: 12,
    lg: 12
  }, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
    className: "create-api-tokens-modal-label-name"
  }, "Api Token Name"), /*#__PURE__*/React.createElement("div", {
    className: "create-api-tokens-modal-label-data"
  }, apiTokenName))), /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
    className: "create-api-tokens-modal-label-name"
  }, "Api Token"), /*#__PURE__*/React.createElement("div", {
    className: "create-api-tokens-modal-label-data"
  }, apiToken))), /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    className: "copy-btn btn",
    onClick: handleCopyToClipboard(apiToken)
  }, copied ? "Copied" : "Copy Token")), /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: "warning"
  }, "For security reasons, we can show you this API token only once. Please copy it and save it somewhere safe. If you lose it, you'll be able to regenerate it.")))))));
};
export default ApiTokens;